<template>
  <div class="title">
    <slot></slot>
    <div class="findUser" v-if="find">
      <el-input
        placeholder="请输入用户编号"
        clearable
        v-model="userNum"
      ></el-input>
      <el-button type="primary" @click="handelFildUser">查询</el-button>
    </div>
  </div>
</template>

<script>
import { getDataAcquisition } from "@/api/energyManagement.js";

export default {
  name: "firstHeading",
  props: {
    find: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      userNum: "",
    };
  },
  methods: {
    async handelFildUser() {
      if (!this.userNum) {
        this.$message.warning("请输入用户编号！");
      } else {
        const res = await getDataAcquisition({ userNum: this.userNum });
        if (res) {
          if (res.data[0].fileUp === 1) {
            this.$message.warning("该用户已经上传了合同！");
          } else {
            this.$parent.$parent.tableData3 = res.data;
          }
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-size: 20px;
  font-weight: 600;
  // margin-bottom: 20px;
  &::before {
    content: "";
    display: inline-block;
    width: 3px;
    height: 16px;
    border-radius: 3px;
    background-color: #068667;
    margin-right: 10px;
  }
  .findUser {
    /* font-weight: 400;
    font-size: 16px; */
    float: right;
    display: flex;
    align-items: center;
    .el-button {
      width: 96px;
      height: 38px;
      margin-left: 10px;
    }
  }
}
</style>
